// @mui material components
import { useState, useEffect, useRef, useCallback, useContext } from "react";
import Card from "@mui/material/Card";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Kaizen Dashboard examples
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Icon from "@mui/material/Icon";
import { urlBase } from "../../services/config";
import { green } from "@mui/material/colors";

import axios from "axios";
import { CircularProgress, Divider, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import Listado from "./components/listado";
import { MessageManager } from "context";
import { Link, useParams } from "react-router-dom";
import { agregarCeros } from "utils/truncate";
import { ConfirmarContext } from "context/ConfirmarContext";

const user = localStorage.getItem("user");
const parsedUser = user ? JSON.parse(user) : null;
const invalidKeysInputNumber = ["e", ".", "-", "+"];

function Tables() {
  const { handleSnackbar } = useContext(MessageManager);
  const { confirmar } = useContext(ConfirmarContext);

  const [remito, setRemito] = useState({
    numeroEmpleado: "",
  });

  const [empleados, setEmpleados] = useState([]);
  const [listadoSucursales, setListadoSucursales] = useState([]);
  const [sucursales, setSucursales] = useState({
    origen: "",
    destino: "",
  });
  const [selected, setSelected] = useState(0);
  const [nuevoProducto, setNuevoProducto] = useState({
    cantidad: "",
    codigo: "",
  });
  const [listadoProductos, setListadoProductos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputCambiado, setInputCambiado] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);

  const [listadoRemito, setListadoRemito] = useState([]);

  const [cargandoPantalla, setCargandoPantalla] = useState(true);

  const totalProductos = listadoRemito
    .filter((item) => !item.dateDel)
    .reduce((acc, item) => acc + Math.abs(parseInt(item.Cantidad)), 0);
  //Ref inputs
  const inputCodigoRef = useRef(null);
  const inputCantidadRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    const getUsuarios = async () => {
      try {
        const response = await axios.get(urlBase + "users");
        setListadoSucursales(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    const getEmpleados = async () => {
      try {
        const response = await axios.get(urlBase + "vendedores");
        setEmpleados(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    getUsuarios();
    getEmpleados();
  }, []);

  const searchProducto = useCallback(async (codigo) => {
    setLoading(true);
    setInputCambiado(false);
    try {
      const response = await axios.get(urlBase + `materialesSearch/${codigo}`);
      setListadoProductos(response.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleChangeNuevoProducto = (e) => {
    if (e.target.name === "cantidad" && e.target.value < 0) {
      e.target.value = 0;
    }
    setNuevoProducto({ ...nuevoProducto, [e.target.name]: e.target.value });
  };
  const handleAddProducto = () => {
    const date = new Date().toLocaleString("af-ZA", {
      hour12: false,
    });
    const productoElegido = listadoProductos[selected];
    if (nuevoProducto.cantidad && listadoProductos.length > 0) {
      const index = listadoRemito.findIndex(
        (item) =>
          item.CodProv == productoElegido.CodProv &&
          item.Nombre == productoElegido.Nombre &&
          item.Rubro == productoElegido.Rubro &&
          item.COLOR == productoElegido.COLOR &&
          item.TALLE == productoElegido.TALLE
      );
      if (index !== -1) {
        const nuevoListado = [...listadoRemito];
        nuevoListado[index].Cantidad =
          nuevoListado[index].Cantidad > 0
            ? nuevoListado[index].Cantidad + parseInt(nuevoProducto.cantidad)
            : nuevoListado[index].Cantidad - parseInt(nuevoProducto.cantidad);
        setListadoRemito(nuevoListado);
      } else {
        setListadoRemito((prev) => [
          ...prev,
          {
            ...listadoProductos[selected],
            Cantidad: -nuevoProducto.cantidad,
            TipoMovimientoRemito: "Envío",
            Movimiento: "Remito Interno",
            Sucursal: parsedUser.nombre,
            Descripcion: listadoProductos[selected].Nombre,
            Fecha: date,
          },
        ]);
      }

      setNuevoProducto({
        cantidad: "",
        codigo: "",
      });
      setListadoProductos([]);
      inputCantidadRef.current.focus();
    }
  };

  useEffect(() => {
    if (itemRefs.current[selected]) {
      itemRefs.current[selected].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selected]);
  const ejecutarAccion = (accion, item) => {
    switch (accion) {
      case "borrar":
        const indexToRemove = listadoRemito.findIndex(
          (producto) => producto.Id == item.Id && producto.cantidad == item.cantidad
        );
        if (!item.dateAdd) {
          setListadoRemito((prev) => {
            prev.splice(indexToRemove, 1);
            return [...prev];
          });
        } else {
          const date = new Date().toLocaleString("af-ZA", {
            hour12: false,
          });
          item.dateDel = date;
          item.estado = "Eliminado";
          setListadoRemito((prev) => {
            prev[indexToRemove] = item;
            return [...prev];
          });
        }

        break;
      default:
        break;
    }
  };

  const handleSave = () => {
    confirmar({
      title: "Advertencia",
      message: "¿Está seguro que desea guardar este remito? ",
      icon: "save",
      func: () => {
        if (id) {
          actualizarRemito("Enviado");
        } else {
          guardarRemito("Enviado");
        }
      },
    });
  };

  const guardarRemito = async (estado) => {
    setLoadingSave(true);
    const date = new Date().toLocaleString("af-ZA", {
      hour12: false,
    });
    try {
      const responseRemito = await axios.post(urlBase + "remitoEncabezados", {
        ...remito,
        codigoSucursal: parsedUser.codigo,
        sucursal: parsedUser.nombre,
        sucursalDestinoNombre: listadoSucursales.find(
          (sucursal) => sucursal.codigo == sucursales.destino
        ).name,
        destino: sucursales.destino,
        empleado: remito.numeroEmpleado,
        detalles: listadoRemito,
        fecha: date,
        estado: estado,
        dateAdd: date,
      });
      setRemito({
        numeroEmpleado: "",
      });
      setListadoRemito([]);
      setSucursales({
        ...sucursales,
        destino: "",
      });
      if (estado === "Enviado") {
        window.open("/pdf/" + responseRemito?.data?.data?.id, "_blank", "rel=noopener noreferrer");
      }
      handleSnackbar("Remito guardado correctamente", "success");
    } catch (error) {
      console.error(error);
      handleSnackbar("Error al guardar el remito", "error");
    } finally {
      setLoadingSave(false);
    }
  };
  //Obtener params id remito
  let { id } = useParams();

  const actualizarRemito = async (estado) => {
    setLoadingSave(true);
    const date = new Date().toLocaleString("af-ZA", {
      hour12: false,
    });
    try {
      await axios.put(urlBase + "remitoEncabezados/" + id, {
        ...remito,
        codigoSucursal: parsedUser.codigo,
        sucursal: parsedUser.nombre,
        sucursalDestinoNombre: listadoSucursales.find(
          (sucursal) => sucursal.codigo == sucursales.destino
        ).name,
        destino: sucursales.destino,
        empleado: remito.numeroEmpleado,
        detalles: listadoRemito.filter((item) => !item.dateDel),
        fecha: date,
        estado: estado,
        dateUpd: date,
      });
      setRemito({
        numeroEmpleado: "",
      });
      setListadoRemito([]);
      setSucursales({
        ...sucursales,
        destino: "",
      });
      if (estado === "Enviado") {
        window.open("/pdf/" + id, "_blank", "rel=noopener noreferrer");
      }
      handleSnackbar("Remito actualizado correctamente", "success");
    } catch (error) {
      console.error(error);
      handleSnackbar("Error al actualizar el remito", "error");
    } finally {
      setLoadingSave(false);
    }
  };

  const obtenerRemito = async (id) => {
    try {
      const response = await axios.get(urlBase + `remitoEncabezados/${id}`);
      setRemito({
        ...response.data.data,
        numeroEmpleado: response.data.data.empleado,
      });
      setSucursales({
        ...sucursales,
        destino: response.data.data.destino,
      });
      if (response.data.data.estado !== "Envio parcial") {
        const listadoFetched = response.data.data.detalles.map((item) => {
          return {
            ...item,
            Cantidad: Math.abs(item.Cantidad),
            Nombre: item.Descripcion,
          };
        });
        setListadoRemito(listadoFetched);
      } else {
        const listadoFetched = response.data.data.detalles_pausa.map((item) => {
          return {
            ...item,
            Cantidad: Math.abs(item.Cantidad),
            Nombre: item.Descripcion,
          };
        });
        setListadoRemito(listadoFetched);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCargandoPantalla(false);
    }
  };
  useEffect(() => {
    if (id) {
      obtenerRemito(id);
    } else {
      setCargandoPantalla(false);
    }
  }, [id]);

  const finalizado = (remito.estado && remito.estado !== "Envio parcial") || false;

  const empleadoElegido = empleados.find((empleado) => {
    return Number(empleado?.NVEND) == remito.numeroEmpleado;
  });
  const disableButton =
    listadoRemito.length === 0 || !empleadoElegido || !sucursales.destino || loadingSave;
  if (cargandoPantalla) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <Grid display="flex" justifyContent="flex-end" pb={1}>
          <Link to="/remitos">
            <SoftButton variant="gradient" color="dark" size="large">
              <Icon>arrow_back</Icon>
              Volver
            </SoftButton>
          </Link>
        </Grid>
        <SoftBox py={20}>
          <Grid display="flex" justifyContent="center">
            <CircularProgress color="primary" />
          </Grid>
        </SoftBox>
        <Footer />
      </DashboardLayout>
    );
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={1}>
        <Grid display="flex" justifyContent="flex-end" pb={1}>
          <Link to="/remitos">
            <SoftButton variant="gradient" color="dark" size="large">
              <Icon>arrow_back</Icon>
              Volver
            </SoftButton>
          </Link>
        </Grid>
        <Card>
          <Grid container spacing={1} px={3} py={2}>
            <Grid item xs={3}>
              <InputLabel>
                <SoftTypography variant="subtitle2" fontWeight="bold">
                  Número de empleado
                </SoftTypography>
              </InputLabel>
              <SoftInput
                type="number"
                disabled={finalizado}
                value={remito.numeroEmpleado}
                onChange={(e) => setRemito({ ...remito, numeroEmpleado: e.target.value })}
                onKeyDown={(e) => {
                  if (invalidKeysInputNumber.includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Grid>
            <Grid item xs={3} display="flex" alignItems="flex-end">
              {empleadoElegido ? (
                <SoftTypography variant="subtitle2">
                  <Icon>person</Icon>
                  {empleadoElegido ? empleadoElegido.NOMBRE : " - "}
                </SoftTypography>
              ) : (
                <SoftTypography variant="subtitle2">
                  <Icon color="error">cancel</Icon>
                  No válido
                </SoftTypography>
              )}
            </Grid>
            <Grid
              item
              xs={6}
              display="flex"
              justifyContent="flex-end"
              flexDirection="column"
              alignItems="flex-end"
            >
              {finalizado && (
                <>
                  <SoftTypography variant="body2" fontWeight="bold">
                    Remito N°:{" "}
                    {remito?.codigoSucursal ? agregarCeros(remito.codigoSucursal, 4) : ""}-
                    {remito.numero}
                  </SoftTypography>
                  <SoftTypography variant="body2" fontWeight="bold">
                    {remito.estado}
                  </SoftTypography>
                </>
              )}
            </Grid>
            <Grid item xs={12} md={5}>
              <InputLabel>
                <SoftTypography variant="subtitle2" fontWeight="bold">
                  Origen
                </SoftTypography>
              </InputLabel>
              <SoftInput value={finalizado ? remito.sucursal : parsedUser.nombre} disabled />
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              display="flex"
              justifyContent="center"
              alignItems="flex-end"
              pb={1}
            >
              <Icon color="primary">swap_horizontal</Icon>
            </Grid>
            <Grid item xs={12} md={5}>
              <InputLabel>
                <SoftTypography variant="subtitle2" fontWeight="bold">
                  Destino
                </SoftTypography>
              </InputLabel>
              <Select
                value={sucursales.destino}
                onChange={(e) => setSucursales({ ...sucursales, destino: e.target.value })}
                disabled={finalizado}
              >
                {parsedUser.nombre == "Deposito"
                  ? listadoSucursales
                      .filter((listado) => listado.codigo !== parsedUser.codigo)
                      .map((sucursal) => (
                        <MenuItem value={sucursal.codigo} key={sucursal.codigo}>
                          {sucursal.name}
                        </MenuItem>
                      ))
                  : parsedUser.nombre == "Dean_Funes"
                  ? listadoSucursales
                      .filter(
                        (listado) =>
                          listado.codigo !== parsedUser.codigo &&
                          (listado.codigo == 9 || listado.codigo == 19)
                      )
                      .map((sucursal) => (
                        <MenuItem value={sucursal.codigo} key={sucursal.codigo}>
                          {sucursal.name}
                        </MenuItem>
                      ))
                  : parsedUser.nombre == "General_Paz"
                  ? listadoSucursales
                      .filter(
                        (listado) =>
                          listado.codigo !== parsedUser.codigo &&
                          (listado.codigo == 9 || listado.codigo == 3)
                      )
                      .map((sucursal) => (
                        <MenuItem value={sucursal.codigo} key={sucursal.codigo}>
                          {sucursal.name}
                        </MenuItem>
                      ))
                  : listadoSucursales
                      .filter(
                        (listado) => listado.codigo !== parsedUser.codigo && listado.codigo == 9
                      )
                      .map((sucursal) => (
                        <MenuItem value={sucursal.codigo} key={sucursal.codigo}>
                          {sucursal.name}
                        </MenuItem>
                      ))}
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {!finalizado && (
              <>
                <Grid item xs={12} spacing={1} container>
                  <Grid item xs={12} md={3}>
                    <InputLabel>
                      <SoftTypography variant="subtitle2" fontWeight="bold">
                        Cantidad
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      placeholder="Cantidad"
                      type="number"
                      name="cantidad"
                      value={nuevoProducto.cantidad}
                      inputRef={inputCantidadRef}
                      onChange={handleChangeNuevoProducto}
                      onKeyDown={(e) => {
                        if (invalidKeysInputNumber.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" && nuevoProducto.cantidad) {
                          inputCodigoRef.current.focus();
                        }
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={9}>
                    <InputLabel>
                      <SoftTypography variant="subtitle2" fontWeight="bold">
                        Código barra producto
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      inputRef={inputCodigoRef}
                      placeholder="Buscar..."
                      onChange={(e) => {
                        setInputCambiado(true);
                        handleChangeNuevoProducto(e);
                      }}
                      value={nuevoProducto.codigo}
                      name="codigo"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowDown") {
                          setSelected((prev) =>
                            prev < listadoProductos.length - 1 ? prev + 1 : 0
                          );
                        } else if (e.key === "ArrowUp") {
                          setSelected((prev) =>
                            prev > 0 ? prev - 1 : listadoProductos.length - 1
                          );
                        } else if (e.key === "Enter" && e.target.value && inputCambiado) {
                          searchProducto(e.target.value);
                        } else if (e.key === "Enter" && e.target.value && !inputCambiado) {
                          handleAddProducto();
                          inputCantidadRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel>
                      <SoftTypography variant="subtitle2" fontWeight="bold">
                        Productos encontrados
                      </SoftTypography>
                    </InputLabel>
                    <Grid container pr={1} mt={1}>
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <SoftTypography variant="subtitle2" fontWeight="bold">
                          Cod. Prov.
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={5} display="flex" justifyContent="flex-start">
                        <SoftTypography variant="subtitle2" fontWeight="bold">
                          Nombre
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={1} display="flex" justifyContent="center">
                        <SoftTypography variant="subtitle2" fontWeight="bold">
                          Talle
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <SoftTypography variant="subtitle2" fontWeight="bold">
                          Color
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={2} display="flex" justifyContent="flex-end">
                        <SoftTypography variant="subtitle2" fontWeight="bold">
                          Código barra
                        </SoftTypography>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      my={1}
                      sx={{
                        border: 1,
                        borderColor: "divider",
                        borderRadius: 2,
                        maxHeight: 150,
                        overflowY: "auto",
                      }}
                    >
                      {loading ? (
                        <Grid item xs={12} display="flex" justifyContent="center" py={4}>
                          <SoftTypography variant="body2">Cargando...</SoftTypography>
                        </Grid>
                      ) : listadoProductos.length > 0 ? (
                        listadoProductos.map((producto, index) => (
                          <Grid
                            item
                            xs={12}
                            key={producto.id}
                            px={2}
                            m={0.2}
                            ref={(el) => (itemRefs.current[index] = el)}
                            display="flex"
                            justifyContent="space-between"
                            sx={{
                              backgroundColor: selected === index ? green[100] : "transparent",
                              borderRadius: 2,
                            }}
                          >
                            <Grid item xs={2} display="flex" justifyContent="center">
                              <SoftTypography variant="subtitle1" color="black">
                                {producto.CodProv}
                              </SoftTypography>
                            </Grid>
                            <Grid item xs={5} display="flex" justifyContent="flex-start">
                              <SoftTypography variant="subtitle1" color="black">
                                {producto.Nombre}
                              </SoftTypography>
                            </Grid>
                            <Grid item xs={1} display="flex" justifyContent="center">
                              <SoftTypography variant="subtitle1" color="black">
                                {producto.TALLE}
                              </SoftTypography>
                            </Grid>
                            <Grid item xs={2} display="flex" justifyContent="center">
                              <SoftTypography variant="subtitle1" color="black">
                                {producto.COLOR}
                              </SoftTypography>
                            </Grid>
                            <Grid item xs={2} display="flex" justifyContent="flex-end">
                              <SoftTypography variant="subtitle1" color="black">
                                {producto.CodigoBarra}
                              </SoftTypography>
                            </Grid>
                          </Grid>
                        ))
                      ) : (
                        <Grid item xs={12} display="flex" justifyContent="center" py={4}></Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </>
            )}
            <Listado
              listadoRemito={listadoRemito}
              ejecutarAccion={ejecutarAccion}
              finalizado={finalizado}
            />
            <Grid
              item
              xs={12}
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              px={2}
            >
              <Grid display="flex">
                <SoftTypography variant="body1">Cantidad de artículos: &nbsp;</SoftTypography>
                <SoftTypography variant="body1" fontWeight="bold">
                  {totalProductos}
                </SoftTypography>
              </Grid>
              <Grid display="flex" gap={2}>
                {!finalizado && (
                  <>
                    <SoftButton
                      size="large"
                      variant="gradient"
                      disabled={disableButton}
                      color="primary"
                      onClick={() => {
                        if (id) {
                          actualizarRemito("Envio parcial");
                        } else {
                          guardarRemito("Envio parcial");
                        }
                      }}
                    >
                      <Icon
                        sx={{
                          mr: 0.4,
                        }}
                      >
                        pause
                      </Icon>
                      {loadingSave ? (
                        <CircularProgress sx={{ margin: "0 15px" }} size={18} color="white" />
                      ) : (
                        "Pausar"
                      )}
                    </SoftButton>
                    <SoftButton
                      size="large"
                      variant="gradient"
                      color="dark"
                      disabled={disableButton}
                      onClick={() => {
                        handleSave();
                      }}
                    >
                      <Icon
                        sx={{
                          mr: 0.4,
                        }}
                      >
                        save
                      </Icon>
                      {loadingSave ? (
                        <CircularProgress sx={{ margin: "0 15px" }} size={18} color="white" />
                      ) : (
                        "Guardar"
                      )}
                    </SoftButton>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
